export default function (name: string, ext = 'mp3') {
     const effect = new Audio(require(`@/assets/sounds/${name}.${ext}`)!)
     effect.play();
}